'use client';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
import { useRef } from 'react';

type MarqueeProps<T extends { id: string | number }> = {
  data: T[];
  renderItem: (item: T) => React.ReactNode;
};

export const Marquee = <T extends { id: string | number }>({
  data,
  renderItem,
}: MarqueeProps<T>) => {
  const plugins = useRef([
    AutoScroll({
      speed: 0.6,
      startDelay: 0,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    }),
  ]);

  return (
    <Carousel
      plugins={plugins.current}
      opts={{ dragFree: true, slidesToScroll: 'auto', loop: true }}
    >
      <CarouselContent>
        {data.map((item) => (
          <CarouselItem key={item.id} className='basis-auto'>
            {renderItem(item)}
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};
